let collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});

const taskResponsesTasksMap = (taskResponses) => {
  let trMap = {};
  taskResponses.forEach(tr => {
    if(!trMap[tr.task.guid]) {
      trMap[tr.task.guid] = []
    }
    trMap[tr.task.guid].push(tr);
  });

  return trMap;
};

const mergeTasksWithResponses = (taskGroups, taskResponses) => {
  let tg = [...taskGroups];
  let trMap = taskResponsesTasksMap(normazileTaskResponses(taskResponses));

  return tg.map(taskGroup => {
    return {
      ...taskGroup.task_group,
      percent: taskGroup.percent,
      reference_responses: taskGroup.reference_responses,
      taskGroupTrainingTrackerGuid: taskGroup.taskGroupTrainingTrackerGuid,
      tasks: taskGroup.task_group.tasks.map(task => {
        return {
          ...task,
          taskResponses: trMap[task.taskGuid] || []
        }
      })
    }
  })
};

const createSubgroups = (taskGroups) => {
  let taskGroupMap = taskGroups.reduce((acc, tg) => {
    if(tg.parent_guid) {
      let taskGroup = acc[tg.parent_guid];
      let subGroups = taskGroup && taskGroup.subGroups || []

      return {
        ...acc,
        [tg.parent_guid]: {
          ...(taskGroup || {}),
          subGroups: [...subGroups, tg]
        }
      }
    } else {
      let taskGroup = acc[tg.taskGroupGuid] || {};
      return {
        ...acc,
        [tg.taskGroupGuid]: {
          ...tg,
          subGroups: taskGroup.subGroups || []
        }
      }
    }
  }, {})

  return Object.keys(taskGroupMap).map(key => ({
    ...taskGroupMap[key],
    subGroups: taskGroupMap[key].subGroups.sort((a, b) => {
      return collator.compare(a.name, b.name)
    })
  }))
}

const getTasksMap = (taskGroups) => {
  let tasksMap = {};
  taskGroups.forEach(taskGroup => {
    taskGroup.task_group.tasks.map(task => {
      tasksMap[task.taskGuid] = task;
    })
  });

  return tasksMap
};

const normazileTaskResponses = (taskResponses) =>
  taskResponses.map(r => ({
    ...r.attributes,
    guid: r.guid,
    type: r.type,
    task: r.task
  }));

const mergeTasksToTaskResponses = (taskGroups, taskResponses) => {
  let tasksMap = getTasksMap(taskGroups);
  let tr = normazileTaskResponses(taskResponses);

  return tr.map(taskResponse => ({
    ...taskResponse,
    task: tasksMap[taskResponse.task.guid]
  }))
}

const getTotalTasks = (tasks) => {
  return tasks? tasks.reduce((total, task) => {
    return total + 1
  }, 0): 0;
}

const getTotalSubGroupsTask = (subGroups) => {
  return subGroups ? subGroups.reduce((sum, sg) => sum + getTotalTasks(sg.tasks), 0): 0
}

const normalizeSubGroupsTasks = (subGroups) => {
  return subGroups? subGroups.reduce((tasks, sg) =>  [...tasks, ...(sg.tasks || [])], []):[]
}

const taskGroupStats = (taskGroup) => {
  let totalTasks = getTotalTasks(taskGroup.tasks) + getTotalSubGroupsTask(taskGroup.subGroups);

  let tasks = (taskGroup.tasks || []);
  tasks = [...tasks, ...normalizeSubGroupsTasks(taskGroup.subGroups) ]

  let completedTasks = tasks.reduce((count, task) => {
    let minResponses = task.min_responses || 1;
    let completedTasksCount = task.taskResponses.filter(tr => tr.status === 'completed' && !tr.substandard).length;
    return (count + (completedTasksCount >= minResponses ? 1 : 0));
  }, 0);

  let waitingAck = tasks.reduce((count, task) => {
    return count + task.taskResponses.filter(tr => !tr.acknowledgedAt && tr.status === 'submitted').length
  }, 0);

  let substandard = tasks.reduce((count, task) => {
    return count + task.taskResponses.filter(tr => tr.substandard).length
  }, 0);

  let rejected = tasks.reduce((count, task) => {
    return count + task.taskResponses.filter(tr => tr.status === 'rejected').length
  }, 0);

  let completed = parseInt(((completedTasks / totalTasks) * 100).toFixed(0));

  return {
    totalTasks,
    completedTasks,
    waitingAck,
    completed,
    substandard,
    rejected,
    completedAll: completed === 100 && waitingAck === 0
  }

};

export {
  mergeTasksWithResponses,
  mergeTasksToTaskResponses,
  createSubgroups,
  taskGroupStats,
  normazileTaskResponses
}
